import React, { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { SpacingScale } from '../spacingScale';
import styles from './Stack.module.scss';

export type StackProps = {
  spacing?: SpacingScale;
  children: ReactNode | ReactNode[];
  component?: keyof HTMLElementTagNameMap | FunctionComponent<any>;
  className?: string;
  alignX?: 'left' | 'center' | 'right' | 'stretch' | 'baseline';
} & HTMLAttributes<any>;

export const Stack = ({
  children,
  spacing = 0,
  component = 'div',
  alignX = 'stretch',
  className,
  ...rest
}: StackProps) =>
  React.createElement(
    component,
    {
      className: classNames(
        styles.wrapper,
        styles[`gap-${spacing}`],
        styles[`alignX-${alignX}`],
        className
      ),
      ...rest,
    },
    children
  );
